
  <!--
 * 页面
 * @LastEditTime: Fri Jan 10 2025 16:12:56 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_4IV716" :class="[curLang]" class="u_r_4IV716 route-page"  ><div id="u_c_TXDP18"  :class="[`normal`,`u_c_TXDP18`]" ><u_c_YFC217></u_c_YFC217></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_YFC217 from "@/components/u_c_YFC217.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"zh-CN":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['zh-CN']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    
    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>
#app{height:100%}
@media screen and (orientation:portrait) { 
 #u_c_YFC217{width:100vw}
}
@media screen and (orientation:landscape) {
 #u_c_YFC217{width:50vw;max-width:750px}
 }
html, body {
height: 100%;
}#app{height:100%}
@media screen and (orientation:portrait) { 
 #u_c_YFC217{width:100vw}
}
@media screen and (orientation:landscape) {
 #u_c_YFC217{width:50vw;max-width:750px}
 }
html, body {
height: 100%;
}
.u_c_TXDP18.normal{
position:relative;
width:100%;
height:100%;
overflow:hidden;
display:flex;
justify-content:center;

}

</style>
